export function schemaExtractor(input) {
  const output = {};
  Object.keys(input).forEach((key) => {
    if (input[key].type === "object" && !Array.isArray(input[key])) {
      output[key] = schemaExtractor(input[key].properties || {});
    } else if (Array.isArray(input[key])) {
      output[key] = [];
    } else {
      switch (input[key].type) {
        case "string":
          output[key] = "";
          break;
        case "number":
          output[key] = "";
          break;
        case "array":
          output[key] = [];
          break;
        case "object":
          output[key] = {};
          break;
        default:
          output[key] = null;
      }
    }
  });

  return output;
}
